import { useNavigate, useParams } from 'react-router-dom';
import { ChatView } from './chat';
import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getRoom } from '../../../common/api/rooms';
import { Spinner } from '@cloudscape-design/components';
import { useUser } from '../../../components/user/UserContext';
import { Loading } from '../../../components/Loading';
// import { useCode } from '../../../components/user/CodeContext';
import { parseStageDates } from '../../../common/stages/stages';

export default function View() {
  const params = useParams();
  const navigate = useNavigate();
  const roomUuid = params.roomUuid;
  useEffect(() => {
    if (!roomUuid) {
      navigate('/');
    }
  }, [roomUuid]);

  return roomUuid ? <ChatContent roomUuid={roomUuid} /> : null;
}

export type ChatContentProps = {
  roomUuid: string;
};

export function ChatContent(props: ChatContentProps) {
  const { user } = useUser();
  // const { code } = useCode();
  const getQuery = useQuery({
    queryKey: ['rooms', props.roomUuid],
    queryFn: async () => getRoom(props.roomUuid),
    enabled: true,
    // room is always changing, so we don't want to cache it
    staleTime: 0,
    gcTime: 0,
  });

  const room = useMemo(() => {
    if (!getQuery.data) {
      return null;
    }
    const resp = {
      ...getQuery.data,
      stages: parseStageDates(getQuery.data.stages),
    };
    return resp;
  }, [getQuery.data]);

  if (getQuery.isLoading || !getQuery.data || !room || !user) {
    // TODO error handling
    return <Loading />;
  }
  return <ChatView roomUuid={props.roomUuid} room={room} user={user} />;
}
